import { differenceInMonths, differenceInWeeks, differenceInYears } from 'date-fns'
import { Frequency } from '@omnea-app/packages/universal/form/elements/pricing'
import { PaymentIntervalEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'

/**
 * Pure interval counting between two already-normalized dates.
 * No date normalization or effectiveEnd logic — callers handle that.
 */
export const countCompleteIntervals = (frequency: Frequency, start: Date, end: Date): number => {
  switch (frequency) {
    case PaymentIntervalEnum.ONE_OFF:
      return 1
    case PaymentIntervalEnum.WEEK:
      return differenceInWeeks(end, start)
    case PaymentIntervalEnum.MONTH:
      return differenceInMonths(end, start)
    case PaymentIntervalEnum.QUARTER:
      return Math.floor(differenceInMonths(end, start) / 3)
    case PaymentIntervalEnum.EVERY_SIX_MONTHS:
      return Math.floor(differenceInMonths(end, start) / 6)
    case PaymentIntervalEnum.YEAR:
      return differenceInYears(end, start)
    case PaymentIntervalEnum.EVERY_TWO_YEARS:
      return Math.floor(differenceInYears(end, start) / 2)
    default:
      assertNever(frequency)
      return 0
  }
}
